import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Seo from "@/components/Seo";

export default function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  // Every authenticated app route (admin/seller/freelancer) is private — keep
  // it out of search indexes and give it a sensible default title.
  const seo = <Seo title="Dashboard" noindex />;

  if (loading) {
    return (
      <>
        {seo}
        <div className="min-h-[70vh] flex items-center justify-center text-muted-foreground text-sm tracking-widest uppercase">
          Loading…
        </div>
      </>
    );
  }
  if (!user || user === false) {
    return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return (
    <>
      {seo}
      {children}
    </>
  );
}
